export default __webpack_public_path__ + "static/media/q-logo-white.909897ae.png";